declare interface Props {
  className: string;
  color?: string;
}

const AnimatedLoaderIcon = ({ className, color }: Props) => {
  return (
    <div
      style={{
        border: color
          ? `4px solid ${color}`
          : '4px solid rgba(255, 255, 255, 1)',
        width: '21px',
        height: '21px',
        borderRadius: '50%',
        borderLeftColor: 'transparent',
        animation: 'spin 1s ease infinite',
      }}
      className={className}
    ></div>
  );
};

export default AnimatedLoaderIcon;
